// src/components/molecules/AdminModal/AdminModal.tsx
import React from 'react';
import { Container, Row, Col, Form } from 'shared-portal-component';
import { z } from 'zod';

import AppModal from '@/components/common/AppModal/AppModal';
import type { AdminFormValues } from '@/types/admin.types';

export interface AdminModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (values: AdminFormValues) => void;

  /** Title shown in the modal header (provided by parent) */
  title: string;

  /** Optional UI details */
  submitText?: string;
  modalSize?: 'sm' | 'md' | 'lg';
  className?: string;

  /** Optional defaults (use when editing) */
  defaultValues?: Partial<{ name: string; email: string; phone: string }>;
}

const MIN_LENGTH = 1;

const adminSchema = z.object({
  name: z.string().min(MIN_LENGTH, 'Name is required'),
  email: z.string().email('Enter a valid email'),
  phone: z.string().min(MIN_LENGTH, 'Phone is required'),
});

const adminFields = [
  { name: 'name',  label: 'Administrator Name*',  placeholder: 'Full name',          required: true, type: 'text' as const },
  { name: 'email', label: 'Administrator Email*', placeholder: 'admin@company.com',  required: true, type: 'email' as const },
  { name: 'phone', label: 'Administrator Phone*', placeholder: '(800) 123-4567',     required: true, type: 'phone' as const },
];

const AdminModal: React.FC<AdminModalProps> = ({
  open,
  onClose,
  onSubmit,
  title,
  submitText = 'Save',
  modalSize = 'lg',
  className = '',
  defaultValues = {},
}) => {
  if (!open) return null;

  return (
    <AppModal onClose={onClose} title={title} size={modalSize} className={className} aria-label={title}>
      <Container fluid>
        <Row spacing="none" justify="center">
          <Col>
            <Form
              schema={adminSchema}
              fields={adminFields}
              defaultValues={defaultValues}
              onSubmit={onSubmit}
              submitText={submitText}
            />
          </Col>
        </Row>
      </Container>
    </AppModal>
  );
};

export default AdminModal;
